export default __webpack_public_path__ + "static/media/poweroff.9e1819b8.svg";